import React, { useState, useEffect, useRef, useCallback } from 'react';

import { 
  Character,
} from "@dndModels";

import DandDCharacterUtilities from "@dndUtilities/char_utilities";

import CharacterRaceInput from "@dndComponents/character/race/CharacterRaceInput";
import ModalOrDrawer from "@components/display/ModalOrDrawer";
import CharacterSidekickCreatureInput from "@dndComponents/character/race/CharacterSidekickCreatureInput";

interface Props {
  character: Character;
  disabled: boolean;
}

const char_util = DandDCharacterUtilities.getInstance();

export default function CharacterRaceButton({
  character,
  disabled,
}: Props) {
  const [open, setOpen] = useState(false);
  const [flashing, setFlashing] = useState(character.sidekick ? (character.sidekick_creature_id === "") : (character.race.source_id === "" || character.race.needs_attention));
  const mounted = useRef(false);

  useEffect(() => { 
    mounted.current = true;

    return () => {
      mounted.current = false;
    };
  }, []);

  const modalClosed = useCallback(() => {
    setTimeout(() => {
      if (character.sidekick ? (character.sidekick_creature_id === "") : (character.race.source_id === "" || character.race.needs_attention)) {
        setFlashing(true);
      } else {
        setFlashing(false);
      }
    }, 100);
  }, []);

  useEffect(() => {
    character.subscription_holder.subscribe("Modal Closed", mounted, modalClosed);
  }, [character, modalClosed]);


  const renderExtras = () => {
    const wide_mode = window.innerWidth > 800;
    return (
      <ModalOrDrawer 
        open={ open } 
        // drawer_only
        width={ wide_mode ? 800 : undefined }
        onClose={() => {
          setOpen(false); 
          character.subscription_holder.modalClosed();
        }}>
        { open &&
          <>
            { character.sidekick ?
              <CharacterSidekickCreatureInput
                char={character}
              />
            :
              <CharacterRaceInput
                character={character}
              />
            }
          </>
        }
      </ModalOrDrawer>
    );
  }

  const className = flashing ? "Flashing clickable" : "clickable";
  let race_name = character.sidekick ? (character.sidekick_creature ? char_util.getUseName(character.sidekick_creature) : "No Creature") : character.race.source ? char_util.getUseName(character.race) : "No Race";
  if (race_name === "No Race" && character.character_options.races_called === "Species") {
    race_name = "No Species";
  }
  return (
    <>
      <div style={{ 
          fontSize: "16px", 
        }}
        className={ disabled ? "" : className }
        onClick={() => {
          if (!disabled) {
            setOpen(true);
          }
        }}>
        { race_name }
      </div>
      <div style={{ 
          fontSize: "10px", 
          color: "gray",
        }}
        className={ disabled ? "" : className }
        onClick={() => {
          if (!disabled) {
            setOpen(true);
          }
        }}>
        { character.sidekick ? "Creature" : character.character_options.races_called }
      </div>
      { renderExtras() }
    </>
  ); 
}
